/**
 * Central configuration file for company statistics.
 * Update these values in ONE place to reflect changes across the entire site.
 */

export const COMPANY_STATS = {
  yearsExperience: "10+",
  happyOrganizations: "200+",
  trainedEmployees: "10,000+",
  satisfactionRate: "98%",
} as const;

// Labels for different languages
export const STAT_LABELS = {
  he: {
    yearsExperience: "שנות ניסיון",
    happyOrganizations: "ארגונים מרוצים",
    trainedEmployees: "עובדים הודרכו",
    satisfactionRate: "שביעות רצון",
  },
  en: {
    yearsExperience: "Years of Experience",
    happyOrganizations: "Happy Organizations",
    trainedEmployees: "Employees Trained",
    satisfactionRate: "Satisfaction Rate",
  },
} as const;

// Helper function to get stats array with labels
export function getStatsArray(language: 'he' | 'en') {
  const labels = STAT_LABELS[language];
  return [
    { number: COMPANY_STATS.yearsExperience, label: labels.yearsExperience },
    { number: COMPANY_STATS.happyOrganizations, label: labels.happyOrganizations },
    { number: COMPANY_STATS.trainedEmployees, label: labels.trainedEmployees },
    { number: COMPANY_STATS.satisfactionRate, label: labels.satisfactionRate },
  ];
}

// Highlights array for Hebrew (used in Certifications component)
export const HIGHLIGHTS_HE = [
  `${COMPANY_STATS.yearsExperience} שנות ניסיון`,
  `${COMPANY_STATS.happyOrganizations} ארגונים מרוצים`,
  `${COMPANY_STATS.trainedEmployees} עובדים הודרכו`,
  `${COMPANY_STATS.satisfactionRate} שביעות רצון`,
];
